import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import BankInfo from '@src/components/shared/sidebar_cards/BankInfo.vue';
import ServiceTeamContact from '@src/components/shared/sidebar_cards/ServiceTeamContact.vue';

interface Props {
	assetsPath: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DefaultSidebar',
  props: {
    assetsPath: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ServiceTeamContact, { "assets-path": __props.assetsPath }, null, 8, ["assets-path"]),
    _createVNode(BankInfo)
  ], 64))
}
}

})